// Rótulo de espera de um jogador na fila.
export const formatWaitingFor = (waitingFor, checkedInNow = false) => {
  if (waitingFor < 0) return 'check-in na próxima';
  if (waitingFor >= 10) return 'Próxima';
  if (waitingFor === 0) return checkedInNow ? 'Check-in agora' : 'Saiu agora';
  const whole = Math.floor(waitingFor);
  const hasHalf = !Number.isInteger(waitingFor);
  if (whole === 0) return 'Meia partida aguardando';
  return `${whole}ª partida${hasHalf ? ' e meia' : ''} aguardando`;
};

// Seção (chave + título) a que um jogador pertence.
export const sectionInfo = (player) => {
  const { waitingFor, checkedInNow } = player;
  if (waitingFor >= 10) return { key: 'priority', title: 'Próximos jogadores' };
  if (waitingFor < 0) return { key: 'checkin', title: 'Check-in na próxima' };
  if (waitingFor === 0) {
    return checkedInNow
      ? { key: 'checkinNow', title: 'Check-in agora' }
      : { key: 'w0', title: 'Saiu agora' };
  }
  const whole = Math.floor(waitingFor);
  const hasHalf = !Number.isInteger(waitingFor);
  if (whole === 0) return { key: 'half', title: 'Meia partida aguardando' };
  return {
    key: `w${whole}${hasHalf ? 'h' : ''}`,
    title: `${whole}ª partida${hasHalf ? ' e meia' : ''} aguardando`,
  };
};

// Agrupa a fila (já ordenada) em seções contíguas.
export const buildQueueSections = (players) => {
  const queue = players
    .filter((p) => !p.isPlaying && p.checkedIn)
    .sort((a, b) => (b.waitingFor - a.waitingFor)
      || ((b.checkedInNow ? 1 : 0) - (a.checkedInNow ? 1 : 0)));

  return queue.reduce((acc, player) => {
    const { key, title } = sectionInfo(player);
    const last = acc[acc.length - 1];
    if (last && last.key === key) last.players.push(player);
    else acc.push({ key, title, players: [player] });
    return acc;
  }, []);
};
